export default function () {
    const $toggleButton = $('#sl-js-toggle-survey-metadata');
    const storedEnableMetadata = localStorage.getItem("enableMetadata");
    const defaultEnableMetadata = $toggleButton.is(':checked');

    // local storage converts bool to string
    const enabled = storedEnableMetadata !== null ? storedEnableMetadata === "true" : defaultEnableMetadata;

    setMetadataEnabled(enabled);

    $toggleButton.siblings('.sl-js-toggle-btn-knob').removeClass('hide');

    $toggleButton.on('click', function () {
        setMetadataEnabled($toggleButton.is(':checked'));
    });

    function setMetadataEnabled(enabled: boolean) {
        const $metadataElements = $('.sl-js-metadata');
        if (enabled) {
            $toggleButton.prop('checked', true);
            $metadataElements.removeClass('hide');
        } else {
            $toggleButton.prop('checked', false);
            $metadataElements.addClass('hide');
        }
        try {
            // Ignore storage error: https://github.com/cloud-solutions/surveylab/issues/666
            localStorage.setItem("enableMetadata", enabled ? "true" : "false");
        } catch (error) {
        }

    }
}
